import {
    MIGRATION_SCREEN_SHOW,
    MIGRATION_SCREEN_HIDE,
} from 'state/actions/migration_screen'

const initialState = {
    isVisible: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case MIGRATION_SCREEN_SHOW: {
        return {
            ...state,
            isVisible: true,
        }
    }
    case MIGRATION_SCREEN_HIDE: {
        return {
            ...state,
            isVisible: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/migration_screen.js